import ajaxUtils from "./ajaxutils";
import utils from "./utils";
import content from "./content";

const wsController = (() => {
  let reconnectCount = 0; // 重连计数器
  let firstReconnectTime = new Date().getTime(); // 首次重连时间
  const WS_ACTIVE_TIMEOUT = 10000;
  const TAB_ID = `${new Date().getTime()}_${Math.random().toString(16).slice(2)}`;
  const CONSULTING_ACTIVE_TTL = 20000;
  const CONSULTING_HEARTBEAT_INTERVAL = 5000;
  let tabPriorityChannel = null;
  let tabPriorityChannelName = "";
  let consultingActive = false;
  let consultingActiveAt = 0;
  let consultingHeartbeatTimer = null;
  let suspendedByActiveConsultingTab = false;
  let activeConsultingTabId = "";
  let activeConsultingExpiresAt = 0;
  let activeTabReconnectTimer = null;

  // 页面级状态随当前页面生命周期存在，刷新或新开 Tab 时都会重新初始化。
  const getPageConnectionState = () => {
    if (!window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__) {
      window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__ = {
        wsOpened: false,
        initialMessageListLoaded: false,
      };
    }
    return window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__;
  };

  const getChannelId = () => utils.getParameterByName("channel_id") || localStorage.getItem("zhini_channel_id") || "";
  const getClientId = () => {
    const channelId = getChannelId();
    return (
      utils.getParameterByName("init_client_id_" + channelId) ||
      utils.getParameterByName("client_id_" + channelId) ||
      localStorage.getItem("zhini_init_client_id_" + channelId) ||
      localStorage.getItem("zhini_client_id_" + channelId) ||
      ""
    );
  };
  const getPriorityStorageKey = () => `zhini_active_consulting_tab_${getChannelId()}_${getClientId()}`;
  const getPriorityChannelName = () => `zhini_ws_priority_${getChannelId()}_${getClientId() || "anonymous"}`;
  const getStoredActiveConsultingTab = () => {
    try {
      return JSON.parse(localStorage.getItem(getPriorityStorageKey()) || "{}");
    } catch (e) {
      return {};
    }
  };
  const storeActiveConsultingTab = (payload) => {
    try {
      localStorage.setItem(getPriorityStorageKey(), JSON.stringify(payload));
      localStorage.setItem(
        `${getPriorityStorageKey()}_event`,
        JSON.stringify(Object.assign({ eventTime: new Date().getTime() }, payload))
      );
    } catch (e) {}
  };
  const postTabPriorityMessage = (payload) => {
    const message = Object.assign({ source: "zhini_ws_priority", tabId: TAB_ID }, payload);
    if (tabPriorityChannel) {
      tabPriorityChannel.postMessage(message);
    }
    storeActiveConsultingTab(message);
  };
  const closeWsForTabPriority = () => {
    const ws = resetConfig.ws;
    if (!ws) {
      return;
    }
    try {
      ws.nativeError = "tab_priority";
      ws.onclose = ws.onerror = ws.onmessage = ws.onopen = () => {};
      ws.close && ws.close();
    } catch (e) {}
    resetConfig.ws = undefined;
    resetConfig.lastActiveTime = 0;
  };
  const stopPing = () => {
    if (resetConfig.pingInterval) {
      clearInterval(resetConfig.pingInterval);
      resetConfig.pingInterval = null;
    }
  };
  const suspendForActiveConsultingTab = (message) => {
    if (!message || message.tabId === TAB_ID) {
      return;
    }
    const now = new Date().getTime();
    if (!message.expiresAt || message.expiresAt <= now) {
      return;
    }
    if (consultingActive && consultingActiveAt >= (message.activeAt || 0)) {
      announceConsultingActive("keep_active");
      return;
    }
    if (consultingActive) {
      consultingActive = false;
      if (consultingHeartbeatTimer) {
        clearInterval(consultingHeartbeatTimer);
        consultingHeartbeatTimer = null;
      }
    }
    activeConsultingTabId = message.tabId;
    activeConsultingExpiresAt = message.expiresAt;
    suspendedByActiveConsultingTab = true;
    closeWsForTabPriority();
    stopPing();
  };
  const releaseActiveConsultingTab = (message) => {
    if (!message || message.tabId !== activeConsultingTabId) {
      return;
    }
    activeConsultingTabId = "";
    activeConsultingExpiresAt = 0;
    suspendedByActiveConsultingTab = false;
  };
  const handleTabPriorityMessage = (message) => {
    if (!message || message.source !== "zhini_ws_priority" || message.tabId === TAB_ID) {
      return;
    }
    if (message.type === "consulting_active") {
      suspendForActiveConsultingTab(message);
    }
    if (message.type === "consulting_inactive") {
      releaseActiveConsultingTab(message);
    }
  };
  const initTabPriorityChannel = () => {
    const nextChannelName = getPriorityChannelName();
    if (tabPriorityChannelName === nextChannelName) {
      return;
    }
    tabPriorityChannelName = nextChannelName;
    if (tabPriorityChannel && tabPriorityChannel.close) {
      try {
        tabPriorityChannel.close();
      } catch (e) {}
    }
    tabPriorityChannel = null;
    if (window.BroadcastChannel) {
      tabPriorityChannel = new BroadcastChannel(tabPriorityChannelName);
      tabPriorityChannel.onmessage = (event) => handleTabPriorityMessage(event.data);
    }
    const stored = getStoredActiveConsultingTab();
    suspendForActiveConsultingTab(stored);
  };
  window.addEventListener("storage", (event) => {
    if (!event.key || event.key !== `${getPriorityStorageKey()}_event` || !event.newValue) {
      return;
    }
    try {
      handleTabPriorityMessage(JSON.parse(event.newValue));
    } catch (e) {}
  });
  const announceConsultingActive = (reason) => {
    consultingActive = true;
    consultingActiveAt = new Date().getTime();
    suspendedByActiveConsultingTab = false;
    activeConsultingTabId = TAB_ID;
    activeConsultingExpiresAt = consultingActiveAt + CONSULTING_ACTIVE_TTL;
    initTabPriorityChannel();
    postTabPriorityMessage({
      type: "consulting_active",
      reason,
      activeAt: consultingActiveAt,
      expiresAt: activeConsultingExpiresAt,
    });
    if (!consultingHeartbeatTimer) {
      consultingHeartbeatTimer = setInterval(() => {
        if (consultingActive) {
          announceConsultingActive("heartbeat");
        }
      }, CONSULTING_HEARTBEAT_INTERVAL);
    }
  };
  const announceConsultingInactive = (reason) => {
    if (!consultingActive) {
      return;
    }
    consultingActive = false;
    if (consultingHeartbeatTimer) {
      clearInterval(consultingHeartbeatTimer);
      consultingHeartbeatTimer = null;
    }
    postTabPriorityMessage({
      type: "consulting_inactive",
      reason,
      activeAt: consultingActiveAt,
      expiresAt: new Date().getTime(),
    });
  };
  const releaseConsultingOnPageExit = () => announceConsultingInactive("page_exit");
  window.addEventListener("pagehide", releaseConsultingOnPageExit);
  window.addEventListener("beforeunload", releaseConsultingOnPageExit);
  const hasValidActiveConsultingTab = () => {
    if (!activeConsultingTabId || activeConsultingTabId === TAB_ID) {
      return false;
    }
    if (activeConsultingExpiresAt <= new Date().getTime()) {
      activeConsultingTabId = "";
      activeConsultingExpiresAt = 0;
      suspendedByActiveConsultingTab = false;
      return false;
    }
    return true;
  };
  const markWsActive = () => {
    resetConfig.lastActiveTime = new Date().getTime();
  };
  const isWsAvailable = () => {
    if (suspendedByActiveConsultingTab && hasValidActiveConsultingTab()) {
      return false;
    }
    const ws = resetConfig.ws;
    if (!ws) {
      return false;
    }
    if (ws.nativeError || ws.readyState !== WebSocket.OPEN) {
      return false;
    }
    return new Date().getTime() - resetConfig.lastActiveTime <= WS_ACTIVE_TIMEOUT;
  };
  const reconnectActiveConsultingTab = (params) => {
    if (!consultingActive || !token) {
      return;
    }
    if (activeTabReconnectTimer) {
      clearTimeout(activeTabReconnectTimer);
    }
    activeTabReconnectTimer = setTimeout(() => {
      activeTabReconnectTimer = null;
      content.startProcess(Object.assign({}, params || {}, {
        errcode: 10003,
        token,
        type: "needMsgList",
        activeTabReconnect: true,
      }));
    }, 300);
  };
  const wsClosed = (type) => {
    let ws = resetConfig.ws;
    if (!ws || ws.nativeError == "auth") {
      return;
    }
    ws.nativeError = type;
    const shouldRecoverActiveTab = consultingActive && type !== "auth" && type !== "tab_priority";
    closeWsHandler(ws, { showMessage: !shouldRecoverActiveTab });
    if (shouldRecoverActiveTab) {
      resetConfig.ws = undefined;
      resetConfig.lastActiveTime = 0;
      reconnectActiveConsultingTab({ reason: "ws_closed" });
      return;
    }
    if (type == "error" || type == "auth") {
      return;
    }
    resetPingEvent();
  };
  const resolveAuth = (data) => {
    if (data.sta == 0) {
      // requestMessageList(); // 知你逻辑为此处刷新会话
      const list = resetConfig.msgWaiting;
      resetConfig.msgWaiting = [];
      const current = new Date().getTime();
      list.forEach((item) => {
        current - item.createTime < 120000 && sendWs(item);
      });
    } else {
      wsClosed("auth");
      if (data.errcode == 4001 || data.errcode == 4003) {
        resetConfig.resetTimeWs = Number.MAX_VALUE;
      }
      if(!shouldReconnect()){
        const sysMsg = {
          msgtype: "system",
          content: "连接已断开，请刷新页面重试！",
          mid: "native_" + new Date().getTime(),
        };
        content.showMoreMessage(sysMsg, true)
      }
      if (data.data.errcode === 10003 && shouldReconnect()) {// websocket接收token过期重新登录
        content.startProcess({
          errcode: data.data.errcode,
          token,
          type: "needMsgList",
        });
        reconnectCount++; //重连次数增加
      }
    }
  };
  const onopen = (evt, params) => {
    markWsActive();
    if (params && params.type === "needMsgList") {
      const isNetworkRecovery = params.reason === "ws_closed" || params.reason === "online";
      requestMessageList(undefined, undefined, {
        // Tab 切换重连保持静默，仅网络异常恢复时显示连接恢复提示。
        showRecoveryMessage: getPageConnectionState().wsOpened && isNetworkRecovery,
      });
      getPageConnectionState().wsOpened = true;
    }
    utils.log("tkyj+++onopen+++" + JSON.stringify(evt.data));
    //this.setState({resetTime: 0});
  };
  const onclose = (evt) => {
    utils.log("tkyj+++onclose+++" + evt.data);
    //this.setState({resetTime: 0});
    wsClosed();
  };
  const onerror = (evt) => {
    utils.log("tkyj+++onerror+++" + evt.data);
    //this.setState({resetTime: 0});
    wsClosed("error");
  };
  const onmessage = (evt) => {
    let data = evt.data;
    if (!(typeof evt.data == "string")) {
      return;
    }
    data = JSON.parse(data || "{}");
    utils.log("tkyj++++onmessage++++" + JSON.stringify(data));
    switch (data.type) {
      case "auth": {
        resolveAuth(data);
        break;
      }
      case "pong": {
        markWsActive();
        resetConfig.pingCount = 0;
        break;
      }
      case "message": {
        markWsActive();
        if (data.data && actionCBs.messageReceived) {
          actionCBs.messageReceived(data.data);
        }
        break;
      }
      default: {
        break;
      }
    }
  };
  const sendWs = (data) => {
    const ws = resetConfig.ws;
    if (ws && ws.nativeError == "auth") {
      return;
    }
    utils.log("tkyj+++sendWs+++" + JSON.stringify(data));
    data.count = data.count == undefined ? 1 : data.count;
    try {
      if (!localStorage.wsNativeId) {
        localStorage.wsNativeId = Math.random();
      }
      data.message.wsNativeId = localStorage.wsNativeId;
      ws.send(JSON.stringify(data.message));
    } catch (e) {
      utils.log("tkyj+++++tryresend++e++" + JSON.stringify(e));
      if (!data.count) {
        return;
      }
      data.count--;
      data.createTime = new Date().getTime();
      resetConfig.msgWaiting.push(data);
      if (data.message.type == "ping") {
        utils.log("tkyj+++++tryresend++resetWs+++++++");
        closeWsHandler(ws);
        resetWs(token);
      } else {
        utils.log("tkyj++tryresend++pingCount+++" + resetConfig.pingCount);
        resetPingEvent(1, true);
        // this.sendWs({message: {type: 'ping'}})
      }
    }
    return true;
  };
  const continuePing = () => {
    if (resetConfig.pingInterval) {
      return;
    }
    resetConfig.pingInterval = setInterval(() => {
      if (suspendedByActiveConsultingTab && hasValidActiveConsultingTab()) {
        return;
      }
      const data = { message: { type: "ping" }, count: 0 };
      resetConfig.pingCount++;
      utils.log("tkyj++++++++pingInterval+++++++" + resetConfig.pingCount);
      if (resetConfig.pingCount > MAX_PING_COUNT) {
        data.count = 1;
        resetConfig.pingCount = 0;
      }
      sendWs(data);
    }, 3000);
  };
  const closeWsHandler = (ws, options = {}) => {
    if (!ws) {
      return;
    }
    ws.wyFinished = true;
    ws.onclose = ws.onerror = ws.onmessage = ws.onopen = () => {};
    // resetConfig.ws = undefined;
    if (options.showMessage !== false) {
      showBreakConnect();
    }
  };
  const showBreakConnect = () =>{
    const sysMsg = {
      msgtype: "system",
      content: "连接已断开，请刷新页面重试！",
      mid: "native_" + new Date().getTime(),
    };

    content.showMoreMessage(sysMsg, true)

  };
  const resetPingEvent = (value, rightNow) => {
    resetConfig.pingCount = value || MAX_PING_COUNT;
    if (rightNow) {
      sendWs({ message: { type: "ping" } });
    }
  };
  const resetWs = (token, params, force) => {
    initTabPriorityChannel();
    if (suspendedByActiveConsultingTab && hasValidActiveConsultingTab() && !consultingActive) {
      return;
    }
    if (resetConfig.ws && !force) {
      return;
    }
    if (resetConfig.ws && force) {
      closeWsForTabPriority();
    }
    const currentTime = new Date().getTime();
    const lastTime = resetConfig.resetTimeWs;
    utils.log("tkyj+++resetWs+++lastTime+++" + lastTime);
    if (!force && currentTime - lastTime < 10000) {
      resetPingEvent();
      return;
    }
    utils.log("tkyj+++resetWs+++from+++" + token);
    resetConfig.resetTimeWs = currentTime;
    const ws = new WebSocket(
      `${
        ajaxUtils.getTestDomain() ? "wss://msg.zhinikefu.com" : "wss://xmsg.h5bqb.top"
      }/wykf/websocket/webplugin?version=0.1.3&token=${token}`
    );
    ws.onopen = (evt) => {
      onopen(evt, params);
    };
    ws.onclose = (evt) => {
      onclose(evt);
    };
    ws.onerror = (evt) => {
      onerror(evt);
    };
    ws.onmessage = (evt) => {
      onmessage(evt);
    };
    resetConfig.ws = ws;
  };
  const MAX_PING_COUNT = 3;
  const resetConfig = {
    ws: undefined,
    resetTimeWs: 0,
    pingCount: 0,
    msgWaiting: [],
    lastActiveTime: 0,
    pingInterval: null,
  };
  const ensureActiveTabWs = (params) => {
    if (!token) {
      return;
    }
    const ws = resetConfig.ws;
    const lastActiveTime = resetConfig.lastActiveTime || 0;
    const wsExpired = new Date().getTime() - lastActiveTime > WS_ACTIVE_TIMEOUT;
    const shouldCreateWs =
      !ws ||
      ws.nativeError ||
      ws.readyState !== WebSocket.OPEN ||
      wsExpired;
    if (!shouldCreateWs) {
      return;
    }
    reconnectActiveConsultingTab(params);
  };
  const actionCBs = {};
  let token = "";
  window.addEventListener("online", (e) => {
    if (shouldReconnect()) {// 检查是否需要重连
      resetConfig.ws = undefined;
      setTimeout(() => {
        content.startProcess({
          errcode: 10003,
          token,
          type: "needMsgList",
          reason: "online",
        });
        reconnectCount++; //重连次数增加
      }, 1000);
    }
  });
  function shouldReconnect() {
    if (reconnectCount === 0) {// 首次重连
      firstReconnectTime = new Date().getTime();
      return true;
    }
    const currentTime = new Date().getTime();
    const timeDifference = (currentTime - firstReconnectTime) / (1000 * 60 * 60); // 当前与首次重连的时间间隔
    if (timeDifference > 1) {// 首次重连超过1小时，重置重连次数和首次重连时间
      reconnectCount = 0;
      firstReconnectTime = currentTime;
    }

    return reconnectCount < 10;// 检查重连次数是否超过10次
  }
  return {
    init: (params) => {
      utils.log("tkyj+++++init+++++++++");
      initTabPriorityChannel();
      actionCBs.messageReceived = params.messageReceived;
      token = params.token;
      resetConfig.ws = undefined;
      resetConfig.lastActiveTime = 0;
      if (!(suspendedByActiveConsultingTab && hasValidActiveConsultingTab() && !consultingActive)) {
        resetWs(params.token, params.params);
        continuePing();
      }
    },
    isWsAvailable() {
      return isWsAvailable();
    },
    isCurrentConsultingActive() {
      return consultingActive;
    },
    setConsultingActive(params = {}) {
      initTabPriorityChannel();
      if (params.active) {
        announceConsultingActive(params.reason || "active");
        ensureActiveTabWs(params.params);
      } else {
        announceConsultingInactive(params.reason || "inactive");
      }
    },
    sendMsgH(params) {
      if (!token) {
        return;
      }
      let channel_id = utils.getParameterByName("channel_id");
      let client_id =  utils.getParameterByName("init_client_id_" + channel_id) || utils.getParameterByName("client_id_" + channel_id)
      let add_params = `&channel_id=${channel_id}&client_id=${client_id}`;
      ajaxUtils.httpRequest({
        type: "POST",
        url: "/wykf/api/v1/enterprise/webplugin/message?version=0.1.3" + add_params,
        contentType: "application/json; charset=UTF-8", // 标准 JSON 头，body 本就是 JSON.stringify 的结果
        data: { token, data: params.message },
        success: (result) => {
          utils.log("tkyj++sendMsgH+++result++++" + JSON.stringify(result));
          params.cb && params.cb(0, result.data);
        },
        error: (res) => {
          if (res.sta === 10003 && params.message.msgtype === "open_chat") {// open_chat自动重试
            content.startProcess({
              errcode: res.sta,
              token,
              type: "needMsgList",
            });
            setTimeout(() => {
              startProcess("sendMsgH", params);
            }, 3000);
          } else {
            if (params.sendCount < 4) {//消息发送失败重试3次
              params.cb &&
                params.cb(
                  -1,
                  { msg: res.msg, errcode: res.sta, token },
                  params.sendCount + 1
                );
            }
          }
        },
      });
    },
    closeWsPingEvent(params) {
      if (params.errcode === 10003 && params.token) {
        clearInterval(resetConfig.pingInterval);
      }
      wsClosed();
    },
  };
})();
const startProcess = (action, params) => {
  wsController[action](params);
};
export default {
  startProcess,
  isWsAvailable: () => wsController.isWsAvailable(),
  isCurrentConsultingActive: () => wsController.isCurrentConsultingActive(),
};



// WEBPACK FOOTER //
// ./src/js/wsUtils.js